export default __webpack_public_path__ + "static/media/payday-payday-loans-ca-4.6e9c813d.jpg";